export default __webpack_public_path__ + "static/OrdpluTi-48962477d196dd7b7823734a610da74a.svg";